import { IconButton, IconButtonProps, Tooltip } from "@mui/material";

/** Icon-only UnavailableButton for dense rows; the label names it for screen readers. */
export const UnavailableIconButton = ({
  label,
  ...props
}: Omit<IconButtonProps, "disabled" | "aria-label"> & { label: string }) => (
  <Tooltip title={`${label}: not available yet`} describeChild>
    <span className="inline-flex">
      <IconButton size="small" aria-label={label} {...props} disabled />
    </span>
  </Tooltip>
);
